"use client";
import {
  type ReactNode,
} from "react";
import {
  type Severity,
} from "../../lib/types";


export function AppLogo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand" aria-label="JarLab">
      <span className="brand-mark" aria-hidden="true">
        <span>[</span>
        <span className="brand-core">J</span>
        <span>]</span>
      </span>
      {!compact && (
        <span className="brand-type">
          jar<span>lab</span>
        </span>
      )}
    </div>
  );
}


export function IconButton({
  label,
  children,
  onClick,
  active,
  className = "",
}: {
  label: string;
  children: ReactNode;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}) {
  return (
    <button
      className={`icon-button ${active ? "is-active" : ""} ${className}`}
      aria-label={label}
      title={label}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
}


export function StatusDot({ severity }: { severity: Severity | "safe" }) {
  return <span className={`status-dot tone-${severity}`} aria-hidden="true" />;
}
